/**
 * @link https://span.studio
 * @copyright Copyright (c) Span Studio LLC
 * @license https://github.com/Span-Studio/sta100-craft5/blob/main/LICENSE.md
 * 
 * Scroll Cue.
 * Toggles the page to scroll via the arrow at the bottom.
 * 
 * @author John Pobojewski <https://john.pobojewski.com
 */

class ScrollCue {
	constructor() {}

	init() {
		console.log("ScrollCue.init()");

		const scrollCue = document.getElementById("scroll-cue");

		// Scroll handler
		window.addEventListener("scroll", () => {
			const scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
			if (scrollTop > 100) {
				scrollCue.classList.add("up");
			} else {
				scrollCue.classList.remove("up");
			}
		});

		// Click handler
		scrollCue.addEventListener("click", function (e) {
			e.preventDefault();
			if (scrollCue.classList.contains("up")) {
				window.scrollTo({ top: 0, behavior: "smooth" });
			}
		});
	}
}

export default new ScrollCue();
